import { useParams } from 'react-router-dom';
import { Feature, useStaffGetFeatureToggles } from '@urbanx/agx.agencies.client';

const useFeatureToggles = (): {
  isEnabled: (feature: Feature) => boolean;
  isLoading: boolean;
} => {
  const { campaignId } = useParams();

  const { data: featureToggles, isPending } = useStaffGetFeatureToggles(
    campaignId || '',
    !!campaignId
  );
  const enabledFeatures = new Set(featureToggles?.enabledFeatures ?? []);

  return {
    isEnabled: (feature) => enabledFeatures.has(feature),
    isLoading: isPending,
  };
};

export default useFeatureToggles;
